// 스플래시 / Welcome / 랜딩이 공유하는 히어로 사진.
//
// 3장을 번갈아 쓴다 — 앱을 켤 때마다 같은 방만 보면 금방 질리고, 우리가 파는
// 게 "여러 스타일" 이라는 것도 드러나지 않는다.
//
// 어떻게 고르나: 앱을 켠 시점에 한 번 정하고 그 세션 동안 고정한다.
// 스플래시 → Welcome → 랜딩이 이어지는 한 흐름이라, 중간에 사진이 바뀌면
// 장면이 끊긴다. 세션 안에서는 같은 방, 다음에 켜면 다른 방.
//
// 순환 순서를 localStorage 에 들고 다니는 이유: 매번 랜덤이면 운 나쁘게
// 같은 사진이 연속으로 나온다. 인덱스를 하나씩 밀면 반드시 3번에 한 번씩
// 돌아온다. 저장이 막힌 환경(사파리 프라이빗 등)에서는 랜덤으로 폴백.

const HEROES = [
  '/marketing/hero-room.jpg',
  '/marketing/hero-room-2.jpg',
  '/marketing/hero-room-3.jpg',
];

const KEY = 'archelier_hero_idx';

function nextIndex() {
  try {
    const prev = parseInt(localStorage.getItem(KEY) ?? '-1', 10);
    const next = (Number.isFinite(prev) ? prev + 1 : 0) % HEROES.length;
    localStorage.setItem(KEY, String(next));
    return next;
  } catch {
    return Math.floor(Math.random() * HEROES.length);
  }
}

// 모듈 로드 시 한 번만 평가 — 세션 내내 같은 값이 유지된다.
export const HERO_IMAGE = HEROES[nextIndex()];

// 나머지 두 장을 미리 받아 둔다. 다음 실행에서 어떤 게 나오든 이미 캐시에
// 있어 사진이 늦게 뜨는 일이 없다. 첫 화면 렌더를 방해하지 않도록
// requestIdleCallback 으로 미룬다.
export function prefetchHeroes() {
  const rest = HEROES.filter((h) => h !== HERO_IMAGE);
  const run = () => rest.forEach((src) => { const i = new Image(); i.src = src; });
  if (typeof requestIdleCallback === 'function') requestIdleCallback(run, { timeout: 3000 });
  else setTimeout(run, 2000);
}

export const HERO_IMAGES = HEROES;
